import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { platformState } from "models/platform";

const initialState: platformState = {
  loading: false,
  data: {},
  message: "",
  success: false,
  platformByIdLoading: false,
  platformByIdSuccess: false,
  platformByIdData: {},
  imgloading: false,
  imageUrl: "",
  updateMessage: "",
  addloading: false,
  addupdateloading: false,
};

const platformSlice = createSlice({
  name: "platforms",
  initialState,
  reducers: {
    getPlatforms(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getPlatformSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getPlatformFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getPlatformById(state, action: PayloadAction<ApiResponse>) {
      state.platformByIdLoading = true;
      state.platformByIdSuccess = false;
      state.platformByIdData = {};
    },
    getPlatformByIdSuccess(state, action: PayloadAction<ApiResponse>) {
      state.platformByIdLoading = false;
      state.platformByIdData = action.payload;
      state.platformByIdSuccess = action.payload.success;
    },
    getPlatformByIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.platformByIdLoading = false;
      state.platformByIdData = action.payload;
      state.platformByIdSuccess = action.payload.success;
    },
    clearPlatformByIdSuccess(state) {
      state.platformByIdLoading = false;
      state.platformByIdSuccess = false;
    },
    addPlatform(state, action: PayloadAction<ApiResponse>) {
      state.addupdateloading = true;
      state.message = "";
    },
    addPlatformSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addupdateloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addPlatformFailed(state, action: PayloadAction<ApiResponse>) {
      state.addupdateloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    updatePlatform(state, action: PayloadAction<ApiResponse>) {
      state.addupdateloading = true;
      state.message = "";
    },
    updatePlatformSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addupdateloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    updatePlatformFailed(state, action: PayloadAction<ApiResponse>) {
      state.addupdateloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    deletePlatform(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    deletePlatformSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    deletePlatformFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getImageUrl(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = true;
      state.imageUrl = "";
    },
    getImageUrlSuccess(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = false;
      state.imageUrl = action.payload.photoURL;
    },
    getImageUrlFailed(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = false;
      state.imageUrl = "";
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.updateMessage = "";
      state.imageUrl = "";
    },
  },
});

export const platformAction = platformSlice.actions;

export const getPlatformsData = (state: RootState) => state.platforms.data;
export const imageLoading = (state: RootState) => state.platforms.imgloading;
export const selectIsLoading = (state: RootState) => state.platforms.loading;
export const getPlatformById = (state: RootState) =>
  state.platforms.platformByIdData;
export const selectIsAddLoading = (state: RootState) =>
  state.platforms.addloading;
export const selectIsAddUpdateLoading = (state: RootState) =>
  state.platforms.addupdateloading;
export const selectIsSuccess = (state: RootState) => state.platforms.success;
export const selectMessage = (state: RootState) => state.platforms.message;
export const selectImageUrl = (state: RootState) => state.platforms.imageUrl;
export const selectUpdateMessage = (state: RootState) =>
  state.platforms.updateMessage;

const platformReducer = platformSlice.reducer;
export default platformReducer;
